import { PopupType } from 'src/app/core/models/common.models';
import { Profile } from './profile.model';

export interface IPopupInputForm {
  popupType: PopupType;
  popupForm: Record<string, any>;
}

export interface IEventReview {
  id: number;
  eventId: number;
  userId: number;
  eventType: EventType;
  review: string;
  rating: number;
  votes: IReviewVote[];
  error?: string;
}

export interface IReviewVote {
  id: number;
  userId: number;
  eventId: number;
  eventReviewId: number;
  voteState: VoteState;
}

export enum VoteState {
  UPVOTE = 'UPVOTE',
  NEUTRAL = 'NEUTRAL',
  DOWNVOTE = 'DOWNVOTE'
}

export interface ICommunityPassports {
  section: string;
  passportProfiles: Profile[];
}

export enum EventType {
  SHOWCASE = 'SHOWCASE',
  SPOTLIGHT = 'SPOTLIGHT',
  SCREENING_PARTY = 'SCREENING_PARTY'
}

export interface IFavoriteEventMutationRequest {
  action: FavoriteEventAction;
  eventId: number;
}

export interface IFavoriteEventMutationResponse {
  message?: string;
  error?: string;
}

export enum FavoriteEventAction {
  SET = 'SET',
  UNSET = 'UNSET'
}
